module.exports = __webpack_public_path__ + "static/media/iksicon.2175fd4d.svg";